import { io } from 'socket.io-client';
import config from '../../config';

let socket = null;

export const getSocket = () => socket;

export const createSocket = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  socket = io(config.api.socketUrl, {
    autoConnect: false,
    reconnection: false,
    transports: ['websocket'],
  });

  return socket;
};
